export default __webpack_public_path__ + "static/media/pexels-rfstudio-3825541.c4c92212.jpg";